import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import states from '../search-mlo/states';
import { MloDetails } from '../search-mlo/mlo-data';
import CustomAvtar from '../search-mlo/custom-avtar';
import {
    Box, Button, Grid, InputLabel, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions,
    Card, CardContent, MenuItem,
    useTheme
} from "@mui/material";
import { ReactComponent as PhoneIcon } from "../assets/borrower-page/PhoneIcon.svg";
import { ReactComponent as EmailIcon } from "../assets/borrower-page/MailIcon.svg";
import { ReactComponent as WebsiteIcon } from "../assets/borrower-page/WebsiteIcon.svg";
import useMediaQuery from '@mui/material/useMediaQuery';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    footerBGS: {
        backgroundColor: "#3d065f",
        color: "white",
        backgroundImage: "url('/images/footerBg.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "10%",
        backgroundPosition: "left 15% bottom",
    },
});

export default function SearchMLO() {
    const [Avtar, setAvtar] = useState(CustomAvtar);
    const [open, setOpen] = useState(false);
    const [selectedState, setSelectedState] = useState("");
    const [filteredMloDetails, setFilteredMloDetails] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        setAvtar(CustomAvtar);

        // Open dialog if the path is /search
        if (location.pathname === '/borrower-portal/search') {
            setOpen(true);
        }
    }, [location]);

    const handleSearch = () => {
        const filteredMlos = MloDetails.filter(mlo => mlo.state.toLowerCase() === selectedState.toLowerCase());
        setFilteredMloDetails(filteredMlos);
    };

    const handleClose = () => {
        setOpen(false);
        navigate('/borrower-portal');
    };

    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth


                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: '#3D065F',
                    },
                }}
            >
                <DialogTitle>Search MLO</DialogTitle>
                <DialogContent>
                    <Box display="flex" flexDirection="column" alignItems="left" paddingX={3}>
                        <Box xs={6} marginLeft={0} mt={4} mb={2}>
                            <InputLabel>Select State</InputLabel>
                        </Box>
                        <TextField
                            select
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            variant="outlined"
                            fullWidth
                            style={{ marginBottom: '20px' }}
                        >
                            {states.map((state) => (
                                <MenuItem key={state.value} value={state.value}>{state.label}</MenuItem>
                            ))}
                        </TextField>
                        <Button onClick={handleSearch} variant="contained" color="primary">
                            Search
                        </Button>
                    </Box>
                    <Box mt={3}>
                        <Grid container spacing={2}>
                            {filteredMloDetails.length === 0 ? (
                                <Box xs={6} marginLeft={{ xs: 12, md: 24 }} mt={2}>
                                    <Typography variant="body1" style={{ color: 'red', textAlign: 'center', marginTop: '1rem' }}>
                                        No matching MLOs found
                                    </Typography>
                                </Box>
                            ) : (
                                filteredMloDetails.map((mlo, index) => (
                                    <Grid item xs={12} key={index}>
                                        <Card style={{ borderRadius: '15px', backgroundColor: '#F5F9FA', padding: '1rem', margin: '1rem' }}>
                                            <CardContent>
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} sm={2} container justifyContent="center" alignItems="flex-start">
                                                        <Box mb={{ xs: 0, md: 6 }}>
                                                            <CustomAvtar />
                                                        </Box>
                                                        <Box mb={{ xs: 0, md: 2 }} ml={{ xs: 2, md: 14 }}>
                                                            <Button
                                                                variant="outlined"
                                                                sx={{
                                                                    fontWeight: 700,
                                                                    fontSize: '0.75rem',
                                                                    color: '#31B9B5',
                                                                    borderColor: '#31B9B5',
                                                                    backgroundColor: 'transparent',
                                                                    marginTop: '0.5rem',
                                                                    '&:hover': {
                                                                        backgroundColor: '#31B9B5',
                                                                        color: '#fff',
                                                                    },
                                                                }}
                                                            >
                                                                Connect with me
                                                            </Button>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4}>
                                                        <Box mb={{ xs: 0, md: 10 }}>
                                                            <Typography variant="h6" sx={{ color: '#31B9B5' }} mb={1}>{mlo.name}</Typography>
                                                            <Typography variant="body2" sx={{ color: '#31B9B5' }} mb={1}>NMLS ID# {mlo.nmlsId}</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Typography variant="body2" textAlign="right" sx={{ color: '#31B9B5' }}>{mlo.companyName}</Typography>
                                                        <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1} mt={3}>
                                                            <Typography variant="body2" textAlign="right" sx={{ color: '#31B9B5' }} mr={1}>{mlo.phone}</Typography>
                                                            <PhoneIcon style={{ width: '1rem', height: '1rem' }} />
                                                        </Box>
                                                        <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1}>
                                                            <Typography variant="body2" textAlign="right" sx={{ color: '#31B9B5' }} mr={1}>{mlo.email}</Typography>
                                                            <EmailIcon style={{ width: '1rem', height: '1rem' }} />
                                                        </Box>
                                                        <Box display="flex" alignItems="center" justifyContent="flex-end" mb={1}>
                                                            <Typography variant="body2" textAlign="right" sx={{ color: '#31B9B5' }} mr={1}>{mlo.website}</Typography>
                                                            <WebsiteIcon style={{ width: '1rem', height: '1rem' }} />
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
